// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home .content {
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: left;
    justify-content: center;
    padding-left: 22vw;
    margin-bottom: 50px;
}

.home .content .wrapper {
    width: 100%;
}

.home .content .name {
    white-space: nowrap;
    font-size: 25px;
    font-weight: 500;
    letter-spacing: 0.3em;
    text-transform: uppercase;
    height: fit-content;
    width: fit-content;
    padding-left: 5px;
}

.home .content .staticTitle {
    font-size: 100px;
    font-weight: 500;
    color: #fff;
    display: flex;
    align-items: center;
    height: fit-content;
    width: fit-content;

}

.home .content .staticTitle .hrLine {
    border-bottom: 3px solid rgba(255, 255, 255, 0.6);
    margin-left: 20px;
    width: 20vw;
}

.home .content .dynamicTitle {
    font-size: 100px;
    font-weight: 500;
    line-height: 100px;
    width: fit-content;

}

.home .content .dynamicTitle li {
    width: 100%;
    z-index: -1;
}

@keyframes slider {
    0%   {width: 0%; }
    50% {width: 42%; }
    100% {width: 0%;}
}

@keyframes fadeText {
    0%   {opacity: 0;}
    100% {opacity: 0;}
}

  .home .content .dynamicTitle li span {
    white-space: wrap;
    background-image: linear-gradient(to right, #ffe1a0, #f67280, #F94892);
    background-clip: text;
    -webkit-text-fill-color: transparent;
    z-index: -1;
  }

  .home .content .dynamicTitle li span::before {
    content: '';
    width: 100%;
    height: 20%;
    z-index: -1;
  }

.mask .bg {
    height: 80vh;
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: -3;
}

@media screen and (max-width: 950px) {
    .mask .bg{
        opacity: 40%;
    }

    .home .content .staticTitle {
        font-size: 90px;
    }

    .home .content .dynamicTitle {
        font-size: 90px;
    }

}

@media screen and (max-width: 750px) {
    .home .content{
        align-items: center;
        padding: 0 12vw;
    }
    .home .content .name {
        font-size: 20px;
        font-weight: 600;
        line-height: 60px;
    }

    .home .content .staticTitle {
        font-size: 12vw;
    }

    .home .content .staticTitle .hrLine {
        width: 22vw;
    }

    .home .content .dynamicTitle {
        font-size: 12vw;
        line-height: 60px;
    }

    .hire {
        font-size: 16px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/HomeBannerStyle.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;;AAEtB;;AAEA;IACI,iDAAiD;IACjD,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;;AAEtB;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,MAAM,SAAS,EAAE;IACjB,KAAK,UAAU,EAAE;IACjB,MAAM,SAAS,CAAC;AACpB;;AAEA;IACI,MAAM,UAAU,CAAC;IACjB,MAAM,UAAU,CAAC;AACrB;;EAEE;IACE,iBAAiB;IACjB,sEAAsE;IACtE,qBAAqB;IACrB,oCAAoC;IACpC,WAAW;EACb;;EAEA;IACE,WAAW;IACX,WAAW;IACX,WAAW;IACX,WAAW;EACb;;AAEF;IACI,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,WAAW;AACf;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;AAEJ;;AAEA;IACI;QACI,mBAAmB;QACnB,eAAe;IACnB;IACA;QACI,eAAe;QACf,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".home .content {\n    height: 100vh;\n    display: flex;\n    flex-direction: column;\n    align-items: left;\n    justify-content: center;\n    padding-left: 22vw;\n    margin-bottom: 50px;\n}\n\n.home .content .wrapper {\n    width: 100%;\n}\n\n.home .content .name {\n    white-space: nowrap;\n    font-size: 25px;\n    font-weight: 500;\n    letter-spacing: 0.3em;\n    text-transform: uppercase;\n    height: fit-content;\n    width: fit-content;\n    padding-left: 5px;\n}\n\n.home .content .staticTitle {\n    font-size: 100px;\n    font-weight: 500;\n    color: #fff;\n    display: flex;\n    align-items: center;\n    height: fit-content;\n    width: fit-content;\n\n}\n\n.home .content .staticTitle .hrLine {\n    border-bottom: 3px solid rgba(255, 255, 255, 0.6);\n    margin-left: 20px;\n    width: 20vw;\n}\n\n.home .content .dynamicTitle {\n    font-size: 100px;\n    font-weight: 500;\n    line-height: 100px;\n    width: fit-content;\n\n}\n\n.home .content .dynamicTitle li {\n    width: 100%;\n    z-index: -1;\n}\n\n@keyframes slider {\n    0%   {width: 0%; }\n    50% {width: 42%; }\n    100% {width: 0%;}\n}\n\n@keyframes fadeText {\n    0%   {opacity: 0;}\n    100% {opacity: 0;}\n}\n\n  .home .content .dynamicTitle li span {\n    white-space: wrap;\n    background-image: linear-gradient(to right, #ffe1a0, #f67280, #F94892);\n    background-clip: text;\n    -webkit-text-fill-color: transparent;\n    z-index: -1;\n  }\n\n  .home .content .dynamicTitle li span::before {\n    content: '';\n    width: 100%;\n    height: 20%;\n    z-index: -1;\n  }\n\n.mask .bg {\n    height: 80vh;\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    z-index: -3;\n}\n\n@media screen and (max-width: 950px) {\n    .mask .bg{\n        opacity: 40%;\n    }\n\n    .home .content .staticTitle {\n        font-size: 90px;\n    }\n\n    .home .content .dynamicTitle {\n        font-size: 90px;\n    }\n\n}\n\n@media screen and (max-width: 750px) {\n    .home .content{\n        align-items: center;\n        padding: 0 12vw;\n    }\n    .home .content .name {\n        font-size: 20px;\n        font-weight: 600;\n        line-height: 60px;\n    }\n\n    .home .content .staticTitle {\n        font-size: 12vw;\n    }\n\n    .home .content .staticTitle .hrLine {\n        width: 22vw;\n    }\n\n    .home .content .dynamicTitle {\n        font-size: 12vw;\n        line-height: 60px;\n    }\n\n    .hire {\n        font-size: 16px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
